/* tslint:disable */

declare var Object: any;
export interface ExportLogInterface {
  "UserId"?: string;
  "page"?: string;
  "downloads"?: number;
  "ip"?: string;
  "city"?: string;
  "country"?: string;
  "region"?: string;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
}

export class ExportLog implements ExportLogInterface {
  "UserId": string;
  "page": string;
  "downloads": number;
  "ip": string;
  "city": string;
  "country": string;
  "region": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: ExportLogInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ExportLog`.
   */
  public static getModelName() {
    return "ExportLog";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ExportLog for dynamic purposes.
  **/
  public static factory(data: ExportLogInterface): ExportLog{
    return new ExportLog(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ExportLog',
      plural: 'ExportLogs',
      path: 'ExportLogs',
      idName: 'id',
      properties: {
        "UserId": {
          name: 'UserId',
          type: 'string'
        },
        "page": {
          name: 'page',
          type: 'string'
        },
        "downloads": {
          name: 'downloads',
          type: 'number'
        },
        "ip": {
          name: 'ip',
          type: 'string'
        },
        "city": {
          name: 'city',
          type: 'string'
        },
        "country": {
          name: 'country',
          type: 'string'
        },
        "region": {
          name: 'region',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}
